import React from "react";
import { Link } from "react-router-dom";
import { Squiggle } from "./Decor";

export const SectionHeading = ({ eyebrow, title, sub, center = false, className = "" }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl ${className}`}>
    {eyebrow && (
      <span className="inline-block font-hand text-2xl text-[#4A90E2]">{eyebrow}</span>
    )}
    <h2 className="font-head font-700 tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#1E293B] mt-1">
      {title}
    </h2>
    {center && <div className="flex justify-center mt-3"><Squiggle color="#FFD166" /></div>}
    {sub && <p className="mt-4 font-body text-base md:text-lg text-[#475569] leading-relaxed">{sub}</p>}
  </div>
);

export const PillLink = ({ to, children, variant = "primary", testid, className = "" }) => {
  const styles = {
    primary: "bg-[#4A90E2] text-white hover:bg-[#2f6fbf]",
    yellow: "bg-[#FFD166] text-[#1E293B] hover:bg-[#f4b83e]",
    ghost: "bg-white text-[#1E293B] border-2 border-[#4A90E2] hover:bg-[#eaf2fc]",
    sage: "bg-[#84A98C] text-white hover:bg-[#5f8468]",
  };
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`inline-flex items-center justify-center gap-2 font-head font-600 text-base px-7 py-3.5 rounded-full shadow-soft-sm hover:-translate-y-0.5 transition-[transform,background-color] duration-200 ${styles[variant]} ${className}`}
    >
      {children}
    </Link>
  );
};
